import { emitStandardEvent } from './standard-events-bridge.js';

const fetchCart = async () => {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
  return response.json();
};

export const cartActionEventTarget = () => (
  document.querySelector('[data-cart-drawer][aria-hidden="false"]')
  || document.querySelector('[data-main-cart]')
  || document.querySelector('[data-cart-drawer]')
  || document
);

export const configureActions = () => {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: cartActionEventTarget,
    async handler(defaultHandler) {
      let result;
      try {
        result = await defaultHandler();
      } catch (error) {
        emitStandardEvent(document, 'CartErrorEvent', {
          error: error instanceof Error ? error.message : String(error),
          code: 'SERVICE_UNAVAILABLE'
        });
        throw error;
      }
      try {
        const cart = await fetchCart();
        window.dispatchEvent(new CustomEvent('pttek:cart:render', { detail: { cart } }));
      } catch (error) {
        console.error('Cart refresh failed after update', error);
        emitStandardEvent(document, 'CartErrorEvent', {
          error: error instanceof Error ? error.message : String(error),
          code: 'SERVICE_UNAVAILABLE'
        });
      }
      return result;
    }
  });

  actions.openCart.configure({
    async handler() {
      window.dispatchEvent(new CustomEvent('pttek:cart-open'));
    }
  });
};

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (window.Shopify?.actions) configureActions();
  else document.addEventListener('DOMContentLoaded', configureActions, { once: true });
}
